module.exports = __webpack_public_path__ + "img/nav_6.90fdb770.png";